import './styles.css';

export type TableProps = {
    innerHTML: string;
};

export const Table = ({ innerHTML: __html }: TableProps) => {
    return <div className="table-class" dangerouslySetInnerHTML={{ __html }} />;
};
